var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadDocDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    width: 15,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.26 11.97h10.92v1.21H2.26v-1.21zM8.33 5.9h4.24l-4.85 4.85L2.87 5.9h4.24V1.05h1.22V5.9z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadDocDark);
export default __webpack_public_path__ + "static/media/download-doc-dark.1a5d9da1.svg";
export { ForwardRef as ReactComponent };